import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mediaroom-version-detail-modal',
  templateUrl: './mediaroom-version-detail-modal.component.html',
  styles: [`
    .modal-content-scroll {
      max-height: 75vh;
      overflow-y: auto;
    }
    .detail-section {
      margin-bottom: 20px;
    }
    .detail-label {
      font-weight: bold;
      color: #343a40;
      display: block;
      margin-bottom: 8px;
      text-transform: uppercase;
      font-size: 0.75rem;
      letter-spacing: 0.5px;
    }
    .detail-value {
      white-space: pre-wrap;
      background: #f8f9fa;
      padding: 12px;
      border-radius: 6px;
      border-left: 4px solid #343a40;
      font-size: 0.95rem;
      color: #333;
    }
    .json-field {
      margin-bottom: 15px;
    }
    .badge-v {
      background: #343a40;
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 0.8rem;
    }
    hr {
      margin: 20px 0;
      opacity: 0.1;
    }
  `]
})
export class MediaRoomVersionDetailModalComponent {
  constructor(
    public dialogRef: MatDialogRef<MediaRoomVersionDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  isObject(val: any): boolean {
    return val !== null && typeof val === 'object' && !Array.isArray(val);
  }
  
  isArray(val: any): boolean {
    return Array.isArray(val);
  }
}
